const handleClick = (e) => {
  const event = new Event("change");

  const input_qty = document.querySelector(".qty-selector");
  const value = parseInt(e.target.getAttribute("data-value"));

  if (!isNaN(value)) {
    input_qty.value = value;
    input_qty.dispatchEvent(event);
  }
};

const handleChange = (e) => {
  const value = parseInt(e.target.value);
  const subtotal = document.querySelector(".subtotal");
  const $price = document.querySelector("[data-price-value]");

  const price = parseInt($price.getAttribute("data-price-value")) / 100;

  if (!isNaN(price)) {
    subtotal.innerHTML = `(${new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
    }).format(value * price)})`;
  }
};

const QuickSelect = () => {
  const buttons = document.querySelectorAll(".quick-qty");
  const input_qty = document.querySelector(".qty-selector");

  if (buttons.length > 0) {
    buttons.forEach((button) => {
      button.addEventListener("click", handleClick);
    });
  }

  if (input_qty) {
    input_qty.addEventListener("change", handleChange);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  QuickSelect();
});
